import * as React from "react";
import type { SVGProps } from "react";
const SvgChevronUpExtraSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16 14.25a1 1 0 0 1-.63-.22L12 11.29l-3.37 2.74a1 1 0 1 1-1.26-1.55l4-3.25a1 1 0 0 1 1.26 0l4 3.25a1 1 0 0 1-.63 1.77"
    />
  </svg>
);
export default SvgChevronUpExtraSmall;
